(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGProductTabs extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
    }

    connectedCallback() {
      this.swiperElement = this.querySelector('yg-swiper');
      this.tabsTitle = this.querySelector('yg-tabs-title');
      this.addEventListener('click', this.handleTabClick);
      this.connectSwiper();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleTabClick);
      this.swiper?.off('slideChange', this.handleSlideChange);
      window.clearTimeout(this.connectTimer);
    }

    connectSwiper() {
      if (!this.isConnected) return;

      if (!this.swiperElement?.swiper) {
        this.connectTimer = window.setTimeout(() => this.connectSwiper(), 50);
        return;
      }

      this.swiper = this.swiperElement.swiper;
      this.swiper.on('slideChange', this.handleSlideChange);
    }

    handleTabClick(event) {
      const tab = event.target.closest('[data-tab-index]');
      if (!tab || !this.contains(tab) || !this.swiper) return;

      const tabIndex = Number.parseInt(tab.dataset.tabIndex, 10);
      if (Number.isNaN(tabIndex) || tabIndex === this.swiper.realIndex) return;

      this.swiper.slideTo(tabIndex);
    }

    handleSlideChange() {
      const activeIndex = this.swiper.realIndex;
      const activeTab = this.tabsTitle?.children[activeIndex];
      if (!activeTab) return;

      this.tabsTitle.toggleClass(activeTab, activeIndex);
      this.tabsTitle.scrollItemIntoView(activeTab, { behavior: 'smooth' });
      Array.from(this.tabsTitle.children).forEach((tab, index) => {
        tab.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
      });
    }
  }

  if (!window.customElements.get('yg-product-tabs')) {
    window.customElements.define('yg-product-tabs', YGProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList01 extends HTMLElement {
        constructor() {
            super();
            this.playbackMode = this.getAttribute('data-playback-mode');
            this.slideItems = this.querySelectorAll('.yg-slide-item');
            this.handleClickPlayback = this.handleClickPlayback.bind(this);
        }
        connectedCallback() {
            if (this.playbackMode === 'click') {
                this.addEventListener('click', this.handleClickPlayback, true);
            }

            if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
                this.initHoverPlayback();
            }
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClickPlayback, true);
        }

        handleClickPlayback(event) {
            const target = event.target instanceof Element ? event.target : null;
            const playButton = target ? target.closest('.yg-play') : null;
            if (!playButton || !this.contains(playButton)) return;

            const currentVideo = playButton.closest('yg-video');
            if (!currentVideo || !this.contains(currentVideo)) return;

            this.pauseOtherVideos(currentVideo);
        }

        pauseOtherVideos(currentVideo) {
            this.querySelectorAll('yg-video').forEach((videoEl) => {
                if (videoEl === currentVideo || typeof videoEl.pauseVideo !== 'function') return;
                videoEl.pauseVideo();
            });
        }

        initHoverPlayback() {
            this.slideItems.forEach(item => {
                const videoEl = item.querySelector('yg-video');
                if (!videoEl) return;

                item.addEventListener('mouseenter', () => {
                    if (videoEl.playVideo) {
                        videoEl.playVideo();
                    }
                });

                item.addEventListener('mouseleave', () => {
                    if (videoEl.pauseVideo) {
                        videoEl.pauseVideo();
                    }
                });
            });
        }
    }
    if (!window.customElements.get('yg-video-list-01')) {
        window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
